/* eslint-disable react/jsx-props-no-spreading */
import { fetchIdentifierTypes } from 'actions/identifier';
import CollapsableCard from 'components/CollapsableCard';
import SelectRedesign from 'components/Select/SelectRedesign';
import { promptBlockTypeOptions } from 'constants/entities';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export type LLMBlock = {
  id: string;
  name: string;
  type: string;
  pattern: string;
  parent?: string;
};

type ComponentProps = {
  block: LLMBlock;
  handleChangeBlock: (block: LLMBlock) => void;
  handleDeleteBlock: (block: LLMBlock) => void;
  handleMoveBlock: (block: LLMBlock, direction: 'up' | 'down') => void;
  handleSelectExpandedBlock: (block: LLMBlock, collpased: boolean) => void;
  isCollapsed: boolean;
};

const PrompSectionCard: React.FC<ComponentProps> = ({
  block,
  handleChangeBlock,
  handleDeleteBlock,
  handleMoveBlock,
  handleSelectExpandedBlock,
  isCollapsed,
}) => {
  const { name, type, pattern, parent } = block;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchIdentifierTypes());
  }, [dispatch]);

  const handleChangeBlockField = (value: string, field: string): void => {
    handleChangeBlock({ ...block, [field]: value });
  };

  return (
    <CollapsableCard
      headerTitle={name}
      containerClasses={`${parent ? 'ml-10' : ''}`}
      isCollapsedProp={isCollapsed}
      collapseCallback={(collapsed: boolean): void => {
        handleSelectExpandedBlock(block, collapsed);
      }}
      useAlternativeColorWhenExpanded
    >
      <div className="py-4 px-6 w-full flex flex-row gap-4">
        <div className="flex flex-1 flex-col gap-4">
          <div className="flex flex-row gap-4">
            <label htmlFor="feature" className="flex flex-1 flex-col gap-1 text-body">
              <div className="flex flex-row">
                <span>Block name</span>
                <span className="text-litlingo-alert">*</span>
              </div>
              <input
                name="feature"
                id="feature"
                type="text"
                data-testid="matcher-feature-input"
                value={name}
                className="form-input h-9 py-2 px-4 border border-litlingo-gray-2 rounded-lg text-body focus:outline-none"
                onChange={(e): void => {
                  handleChangeBlockField(e.target.value, 'name');
                }}
                pattern=".*\S.*"
              />
            </label>

            <div className="w-45 flex flex-col gap-1 text-body">
              <div className="flex flex-row">
                <span>Type</span>
                <span className="text-litlingo-alert">*</span>
              </div>
              <SelectRedesign
                onChange={(value): void => {
                  handleChangeBlockField(value, 'type');
                }}
                options={promptBlockTypeOptions}
                value={type}
                className="h-9"
              />
            </div>
          </div>
          <label htmlFor="feature" className="flex flex-col gap-1 text-body">
            <div className="flex flex-row">
              <span>Pattern Placeholder Text</span>
            </div>

            <textarea
              id="pattern"
              name="pattern"
              rows={5}
              value={pattern}
              onChange={(e): void => {
                handleChangeBlockField(e.target.value, 'pattern');
              }}
              placeholder=""
              className="form-input w-full p-2 text-body rounded-md resize-none placeholder-italic placeholder-litlingo-gray-6 border-litlingo-gray-2"
            />
          </label>
        </div>
        <div className="pt-6 flex flex-col justify-between">
          <div className="flex flex-col gap-2">
            <button
              type="button"
              className="button button--secondary w-36 h-8 justify-center"
              onClick={(): void => {
                handleMoveBlock(block, 'up');
              }}
            >
              <span className="font-bold">Move Up</span>
            </button>
            <button
              type="button"
              className="button button--secondary w-36 h-8 justify-center"
              onClick={(): void => {
                handleMoveBlock(block, 'down');
              }}
            >
              <span className="font-bold">Move Down</span>
            </button>
          </div>
          <div className="flex flex-col gap-2">
            <button
              type="button"
              className="button button--secondary w-36 h-8 justify-center"
              onClick={(): void => {
                handleDeleteBlock(block);
              }}
            >
              <span className="font-bold">Delete</span>
            </button>
          </div>
        </div>
      </div>
    </CollapsableCard>
  );
};

export default PrompSectionCard;
